import { FETCH_SMELTERS } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SMELTERS:
			return action.payload;
		default:
			return state;
	}
};
